import { useState, useEffect, useCallback, useRef } from "react";
import ShimmerLoader from "../../components/ShimmerLoader";
import { useDispatch, useSelector } from "react-redux";
import { fetchwithdrawalrequest, fetchWalletbalance, verifyifsc, DoWithdrawalRequest } from "../wallet/walletSlice";
import { selectCurrentUser } from "../auth/authSlice";
import Moment from "moment";
import { format, parseISO } from "date-fns";
import { Funnel, CirclePlus, User, Wallet, RotateCw, X, Calendar, LogOut, Settings, ChevronDown } from "lucide-react";
import {
    MapPin,
    Building2,
    Home,
    Map,
    Globe,
    Phone,
    Hash,
    Fingerprint
} from 'lucide-react';
import CurFt from "../../components/CurFt";
import Pagination from "../../components/Pagination";
import useDocumentTitle from "../../hooks/useDocumentTitle";
import { Dialog } from "@headlessui/react";
import { toast } from "react-hot-toast";
export default function Withdrawalrequest() {
    useDocumentTitle("Withdrawal Request");
    const debounceTimer = useRef(null);
    const dispatch = useDispatch();
    const { withdrawalStatus, walletbalanceStatus, walletbalanceData } = useSelector((state) => state.wallet);
    const perPage = 25;
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    const [BookingHistory, SetWalletHistory] = useState([]);

    const [available_credit, setavailable_credit] = useState(0);
    const [total_credit_limit, settotal_credit_limit] = useState(0);
    const [totalOutStanding, settotalOutStanding] = useState(0);

    const user = useSelector(selectCurrentUser);
    const [showFilters, setShowFilters] = useState(false);
    const [FilterData, setFilterData] = useState({
        filterType: "Flight",
        referenceno: null,
        FromDate: null,
        ToDate: null,
        customer_id: user?.UserData?.id,
    });
    const fetchwithdrawalrequestS = async () => {
        const response = await dispatch(fetchwithdrawalrequest({ FilterData, perPage, currentPage })).unwrap();
        const data = response.data;
        setavailable_credit(data?.sums?.grand_total || 0);
        settotal_credit_limit(data?.sums?.pending || 0);
        settotalOutStanding(data?.sums?.approved || 0);
        // settotalProfit(data.totalProfit);
        SetWalletHistory(data?.data?.data || data);
        setTotalPages(data?.data?.last_page);
    };
    useEffect(() => {
        fetchwithdrawalrequestS();
    }, [FilterData, currentPage]);
    useEffect(() => {
        return () => {
            if (debounceTimer.current) {
                clearTimeout(debounceTimer.current);
            }
        };
    }, []);

    const toggleFilters = () => {
        setShowFilters(!showFilters);
    };

    const handleFilterChange = (field, value) => {
        setFilterData((prev) => ({
            ...prev,
            [field]: value,
        }));
    };
    const [isSectorModalOpen, setIsModalSector] = useState(false);
    const [loading, setloading] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [formData, setFormData] = useState({
        customer_id: user?.UserData?.id,
        PaymentMode: "Make Online",
        amount: 0,
        walletbalance: 0,
        referenceno: "REF" + Date.now(),
        Account_Name: '',
        remarks: "Withdrawal note",
        Account_No: '',
        IFSC_Code: '',
        Account_Type: '',
    });
    // const handleChange = (eOrName: any, value?: any) => {
    //     if (typeof eOrName === "string") {
    //         // Case: custom components like DateInput
    //         setFormData((prev) => ({
    //             ...prev,
    //             [eOrName]: value,
    //         }));
    //     } else {
    //         // Case: normal <input />, <select />, etc.
    //         const e = eOrName;
    //         setFormData((prev) => ({
    //             ...prev,
    //             [e.target.name]: e.target.value,
    //         }));
    //     }
    // };

    const handleChange = useCallback((e) => {
        const { name, value } = e.target;

        setFormData(prev => ({ ...prev, [name]: value }));

        if (name === 'IFSC_Code') {
            const isValidIFSC = (ifsc) => /^[A-Z]{4}0[A-Z0-9]{6}$/.test(ifsc);

            // Clear previous timer
            if (debounceTimer.current) {
                clearTimeout(debounceTimer.current);
            }

            // Set new debounce timer
            debounceTimer.current = setTimeout(async () => {
                if (isValidIFSC(value)) {
                    const Payload = { ifsc: value };
                    const response = await dispatch(
                        verifyifsc({ Payload })
                    ).unwrap();
                    let data = response?.data?.data?.data || []
                    setFormData((prev) => ({
                        ...prev,
                        ['ifscdetails']: data,
                    }));
                }
            }, 500); // 500ms debounce delay
        }
    }, [dispatch]);

    useEffect(() => {
        if (isSectorModalOpen) {
            const balanceReq = {
                customer_id: user?.UserData?.user?.id,
            };
            dispatch(fetchWalletbalance({ balanceReq }));
        }
    }, [isSectorModalOpen]);

    useEffect(() => {
        if (walletbalanceStatus === true && walletbalanceData?.status?.success === true) {
            setFormData((prev) => ({
                ...prev,
                ['walletbalance']: walletbalanceData?.balances?.wallet_balance || 0,
            }));
        }
    }, [walletbalanceStatus, walletbalanceData]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        let txnid = "TXN" + Date.now();

        if (formData.amount === 0) {
            toast.error("Amount can not be ZERO", { autoClose: 2000 });
            return false;
        }
        if (parseFloat(formData.amount) > (formData.walletbalance)) {
            toast.error("Withdrawal Amount can't be greater than withdrawable balance.", { autoClose: 2000 });
            return false;
        }
        if (parseFloat(formData.amount) < 500) {
            toast.error("Withdrawal Amount can't be less than 500.", { autoClose: 2000 });
            return false;
        }
        if (formData.referenceno === "") {
            toast.error("Enter your reference no", { autoClose: 2000 });
            return false;
        }
        if (formData.Account_Name === "") {
            toast.error("Enter account holder name", { autoClose: 2000 });
            return false;
        }
        if (formData.Account_No === "") {
            toast.error("Enter your account number", { autoClose: 2000 });
            return false;
        }
        if (formData.IFSC_Code === "") {
            toast.error("Enter IFSC Code", { autoClose: 2000 });
            return false;
        }
        if (formData.Account_Type === "") {
            toast.error("Select account type", { autoClose: 2000 });
            return false;
        }
        setloading(true)

        const payload = formData;
        const response = await dispatch(DoWithdrawalRequest(payload)).unwrap();
        if (response.data.status.success) {
            setSubmitted(true)
            toast.success(response.data.message, { autoClose: 2000 });
            fetchwithdrawalrequestS();
        }
        setloading(false);
    };

    const DetailCard = ({ icon: Icon, label, value, iconBg, iconColor }) => (
        <div className="flex items-center p-1 bg-[#F8FAFC] rounded-md border border-gray-50 shadow-sm">
            <div className={`p-2 rounded-md ${iconBg} ${iconColor} mr-2`}>
                <Icon size={15} />
            </div>
            <div>
                <p className="text-sm font-medium text-gray-500 mb-0.5">{label}</p>
                <p className="text-[12px] font-normal text-slate-900 uppercase tracking-tight">{value}</p>
            </div>
        </div>
    );
    return (
        <div className="bg-gray-100 text-gray-800 relative min-h-screen">
            {/* Main Content */}
            <Dialog
                open={isSectorModalOpen}
                onClose={() => setIsModalSector(false)}
                className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
            >
                <div className="bg-white w-full max-w-xl rounded-2xl max-h-[90vh] shadow-lg p-6 overflow-y-auto">
                    {/* Header Row */}
                    <div className="flex items-center justify-between w-full border-b pb-2 mb-4">
                        <h2 className="text-lg font-semibold">Make Withdrawal Request</h2>
                        <button onClick={() => setIsModalSector(false)} className="text-gray-500 hover:text-gray-700">
                            <X size={20} />
                        </button>
                    </div>

                    {/* Form */}
                    {submitted ? (
                        <>
                            <p className="text-gray-500">Hey there! We are pleased to inform you that your withdrawal request has been successfully processed. You can expect it to be credited back to your bank account within the next 07 working days. ⏳</p>
                            <p className="text-gray-500 mt-4">Thank you once again for choosing us and we look forward to serving you again soon! 🌟</p>
                        </>
                    ) : (
                        <form className="space-y-4" onSubmit={handleSubmit}>
                            <p className="text-red-500">Minimum Withdrawal <CurFt currency={user?.UserData?.user?.symbal?.name || "INR"} price={500} /> allowed.</p>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                {/* Amount */}
                                <div className="flex flex-col">
                                    <label className="text-sm font-medium mb-1">Withdrawal Amount</label>
                                    <input
                                        type="number"
                                        name="amount"
                                        value={formData.amount}
                                        onChange={handleChange}
                                        // onInput={handleInput}
                                        placeholder="eg-5000"
                                        className="w-full border rounded-lg px-3 py-2 [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                                        style={{
                                            MozAppearance: "textfield",
                                        }}
                                    />
                                </div>

                                <div className="flex flex-col">
                                    <label className="text-sm font-medium mb-1">Withdrawable balance</label>
                                    <p className="mt-2"><CurFt currency={user?.UserData?.user?.symbal?.name || "INR"} price={formData.walletbalance} /></p>
                                </div>

                                {/* Reference No */}
                                <div className="flex flex-col">
                                    <label className="text-sm font-medium mb-1">Account Holder Name</label>
                                    <input
                                        type="text"
                                        name="Account_Name"
                                        value={formData.Account_Name}
                                        onChange={handleChange}
                                        placeholder="eg-Jone Kumar"
                                        className="w-full border rounded-lg px-3 py-2"
                                    />
                                </div>
                                <div className="flex flex-col">
                                    <label className="text-sm font-medium mb-1">Account Number</label>
                                    <input
                                        type="text"
                                        name="Account_No"
                                        value={formData.Account_No}
                                        onChange={handleChange}
                                        placeholder="eg-00600350000123"
                                        className="w-full border rounded-lg px-3 py-2"
                                    />
                                </div>
                                <div className="flex flex-col">
                                    <label className="text-sm font-medium mb-1">IFSC Code</label>
                                    <input
                                        type="text"
                                        name="IFSC_Code"
                                        value={formData.IFSC_Code}
                                        onChange={handleChange}
                                        placeholder="eg-KKBK0000811"
                                        className="w-full border rounded-lg px-3 py-2"
                                    />
                                </div>
                                <div className="flex flex-col">
                                    <label className="text-sm font-medium mb-1">Account Type</label>
                                    <select onChange={handleChange} value={formData.Account_Type} id="Account_Type" name="Account_Type"
                                        className="w-full border rounded-lg px-3 py-2" >
                                        <option value="">Select Account Type</option>
                                        <option value="Savings">Savings</option>
                                        <option value="Current">Current</option>
                                        <option value="Salary">Salary</option>
                                        <option value="Fixed Deposit">Fixed Deposit</option>
                                        <option value="Recurring Deposit">Recurring Deposit</option>
                                        <option value="NRI">NRI</option>
                                    </select>
                                </div>

                            </div>
                            {formData?.ifscdetails && (
                                <div className="flex flex-col">
                                    <div className="w-full bg-white font-sans">
                                        {/* Header Section */}
                                        <div className="flex items-center gap-2 mb-2 ml-2">
                                            <MapPin className="text-blue-600" size={20} />
                                            <h2 className="text-md font-bold text-slate-800">Branch Location & Details</h2>
                                        </div>

                                        {/* Primary Grid: 2 Columns */}
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-2">
                                            <DetailCard
                                                icon={Building2}
                                                label="Branch Name"
                                                value={formData?.ifscdetails?.branch}
                                                iconBg="bg-purple-100"
                                                iconColor="text-purple-600"
                                            />
                                            <DetailCard
                                                icon={Home}
                                                label="City"
                                                value={formData?.ifscdetails?.city}
                                                iconBg="bg-green-100"
                                                iconColor="text-green-600"
                                            />
                                            <DetailCard
                                                icon={Map}
                                                label="District"
                                                value={formData?.ifscdetails?.city} // District usually matches city in bank data
                                                iconBg="bg-amber-100"
                                                iconColor="text-amber-500"
                                            />
                                            <DetailCard
                                                icon={Globe}
                                                label="State"
                                                value={formData?.ifscdetails?.state}
                                                iconBg="bg-red-100"
                                                iconColor="text-red-500"
                                            />
                                        </div>

                                        {/* Full Width Section: Address */}
                                        <div className="mb-2">
                                            <div className="flex items-center p-1 bg-[#F8FAFC] rounded-md border border-gray-50 shadow-sm">
                                                <div className="p-2 rounded-md bg-blue-100 text-blue-600 mr-2">
                                                    <MapPin size={15} />
                                                </div>
                                                <div>
                                                    <p className="text-sm font-medium text-gray-500 mb-0.5">Address</p>
                                                    <p className="text-[12px] font-normal text-slate-900 uppercase leading-relaxed">
                                                        {formData?.ifscdetails?.address}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Bottom Grid: Multi-info */}
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                            <DetailCard
                                                icon={Hash}
                                                label="IFSC Code"
                                                value={formData?.ifscdetails?.ifsc}
                                                iconBg="bg-indigo-100"
                                                iconColor="text-indigo-600"
                                            />
                                            <DetailCard
                                                icon={Fingerprint}
                                                label="MICR Code"
                                                value={formData?.ifscdetails?.micr}
                                                iconBg="bg-cyan-100"
                                                iconColor="text-cyan-600"
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}
                            <div className="flex flex-col">
                                <label className="text-sm font-medium mb-1">Note</label>
                                <textarea
                                    name="remarks"
                                    value={formData.remarks}
                                    onChange={handleChange}
                                    placeholder="eg- bank name, Transaction ID, cheque number, branch address...."
                                    rows={3}
                                    className="w-full border rounded-lg px-3 py-2"
                                />
                            </div>

                            {/* Submit */}
                            <div className="flex justify-end">
                                <button
                                    type="submit"
                                    disabled={loading === true}
                                    className={`bg-blue-500 text-white px-5 py-2 rounded-md hover:blue-600 transition ${loading === true ? "bg-gray-400 cursor-not-allowed" : "bg-blue-500 hover:bg-blue-600"
                                        }`}
                                >
                                    {loading === true ? <>Please wait...</> : <>Submit</>}
                                </button>
                            </div>
                        </form>
                    )}

                </div>
            </Dialog>
            <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-4 space-y-6">
                <div className="bg-white shadow-md rounded-lg p-4 mt-4">
                    {/* Header */}
                    <div className="flex items-center justify-between">
                        <h3 className="font-semibold">Withdrawal Request</h3>
                        <span className="font-semibold text-blue-500 flex items-center gap-1">
                            <div className="relative text-blue-500 text-left">
                                TOTAL REQUEST
                                <br />
                                <span className="text-1">
                                    <CurFt currency={user?.UserData?.user?.symbal?.name || "INR"} price={available_credit} />
                                </span>
                            </div>
                        </span>
                        <span className="font-semibold flex items-center gap-1">
                            <div className="relative text-gray-500 text-left">
                                TOTAL PENDING
                                <br />
                                <span className="text-1">
                                    <CurFt currency={user?.UserData?.user?.symbal?.name || "INR"} price={total_credit_limit} />
                                </span>
                            </div>
                        </span>
                        <span className="font-semibold flex items-center gap-1">
                            <div className="relative text-orange-500 text-left">
                                TOTAL PROCESSED
                                <br />
                                <span className="text-1">
                                    <CurFt currency={user?.UserData?.user?.symbal?.name || "INR"} price={totalOutStanding} />
                                </span>
                            </div>
                        </span>
                        <span className="font-normal text-blue-500 flex items-center gap-1">
                            <div className="relative inline-block text-left">
                                <button
                                    onClick={() => setIsModalSector(true)}
                                    className={`px-5 py-2 rounded font-medium shadow transition flex items-center gap-2 ${showFilters ? "bg-blue-600 text-white" : "bg-blue-500 hover:bg-blue-600 text-white"
                                        }`}
                                >
                                    <CirclePlus />New Request
                                </button>

                            </div>
                            <div className="relative inline-block text-left">
                                <button
                                    onClick={toggleFilters}
                                    className={`px-5 py-2 rounded font-medium shadow transition flex items-center gap-2 ${showFilters ? "bg-blue-600 text-white" : "bg-blue-500 hover:bg-blue-600 text-white"
                                        }`}
                                >
                                    <Funnel />
                                </button>
                            </div>

                        </span>
                    </div>
                </div>
                {showFilters && (
                    <div className="bg-white shadow-md rounded-lg p-6 mt-4">
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
                            {/* First Column */}
                            <div className="space-y-4">
                                <div>
                                    <label className="block text-sm font-medium mb-2">Reference Number</label>
                                    <input
                                        type="text"
                                        value={FilterData.referenceno}
                                        onChange={(e) => handleFilterChange("referenceno", e.target.value)}
                                        className="w-full border rounded-lg px-3 py-2 text-sm"
                                        placeholder="Reference Number"
                                    />
                                </div>
                            </div>

                            {/* Second Column */}
                            <div className="space-y-4">
                                <div>
                                    <label className="block text-sm font-medium mb-2">Booking From Date</label>
                                    <div className="relative">
                                        <input
                                            type="date"
                                            value={FilterData.FromDate ? new Date(FilterData.FromDate).toISOString().split("T")[0] : ""}
                                            onChange={(e) => {
                                                const date = e.target.value;
                                                const formattedDate = date ? new Date(date + "T18:30:00.000Z").toISOString() : null;
                                                handleFilterChange("FromDate", formattedDate);
                                            }}
                                            max={new Date().toISOString().split("T")[0]}
                                            className="w-full border rounded-lg px-3 py-2 text-sm pr-10 bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        />
                                        {FilterData.FromDate && (
                                            <button
                                                type="button"
                                                onClick={() => handleFilterChange("FromDate", null)}
                                                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-red-500 transition-colors"
                                            >
                                                ✕
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* Third Column */}
                            <div className="space-y-4">
                                <div>
                                    <label className="block text-sm font-medium mb-2">Booking To Date</label>
                                    <div className="relative">
                                        <input
                                            type="date"
                                            value={FilterData.ToDate ? new Date(FilterData.ToDate).toISOString().split("T")[0] : ""}
                                            onChange={(e) => {
                                                const date = e.target.value;
                                                const formattedDate = date ? new Date(date + "T18:30:00.000Z").toISOString() : null;
                                                handleFilterChange("ToDate", formattedDate);
                                            }}
                                            // max={new Date().toISOString().split("T")[0]}
                                            className="w-full border rounded-lg px-3 py-2 text-sm pr-10 bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        />
                                        {FilterData.ToDate && (
                                            <button
                                                type="button"
                                                onClick={() => handleFilterChange("ToDate", null)}
                                                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-red-500 transition-colors"
                                            >
                                                ✕
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* Empty columns for spacing */}
                            <div className="space-y-4"></div>
                            <div className="space-y-4"></div>

                            {/* Close Button in the last column */}
                            <div className="space-y-4">
                                <div className="pt-6">
                                    <button
                                        onClick={() => setShowFilters(false)}
                                        className="w-full bg-gray-500 text-white px-4 py-2 rounded-lg hover:bg-gray-600 transition-colors"
                                    >
                                        Close Filters
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                <div className="bg-white shadow-md rounded-lg overflow-hidden p-2">
                    <div className="overflow-x-auto">
                        <table className="min-w-full border  text-sm">
                            <thead className="bg-gray-100 text-gray-700">
                                <tr>
                                    <th className="px-3 py-2 border text-left">No.</th>
                                    <th className="px-3 py-2 border text-left" nowrap="true">
                                        Trx Date
                                    </th>
                                    <th className="px-3 py-2 border text-left" nowrap="true">
                                        Reference No
                                    </th>
                                    <th className="px-3 py-2 border text-left">Account Name</th>
                                    <th className="px-3 py-2 border text-left">Account Number</th>
                                    <th className="px-3 py-2 border text-left">IFSC Code</th>
                                    <th className="px-3 py-2 border text-left">Remarks</th>

                                    <th className="px-3 py-2 border text-right" nowrap="true">
                                        Amount
                                    </th>
                                    <th className="px-3 py-2 border text-left" nowrap="true">
                                        Status
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {withdrawalStatus === "loading" ? (
                                    <>
                                        <tr className="border-b">
                                            <td className="px-3 py-2 border" colSpan={12}>
                                                <ShimmerLoader />
                                                <ShimmerLoader />
                                                <ShimmerLoader />
                                                <ShimmerLoader />
                                                <ShimmerLoader />
                                            </td>
                                        </tr>
                                    </>
                                ) : (
                                    <>
                                        {BookingHistory?.length > 0 ? (
                                            BookingHistory.map((item, key) => (
                                                <tr className="border-b" key={key}>
                                                    <td className="px-3 py-2 border">{key + 1}</td>
                                                    <td className="px-3 py-2 border" nowrap="true">
                                                        {format(parseISO(item.created_at), "dd MMM, yyyy")}
                                                        <br />
                                                        {Moment(item.created_at).format("h:mm A")}
                                                    </td>
                                                    <td className="px-3 py-2 border" nowrap="true">
                                                        {item.referenceno}<br />
                                                        CR Ref.: - {item.credit_ref || ''}
                                                    </td>
                                                    <td className="px-3 py-2 border" nowrap="true">
                                                        {item.Account_Name}
                                                    </td>
                                                    <td className="px-3 py-2 border" nowrap="true">
                                                        {item.Account_No}
                                                    </td>
                                                    <td className="px-3 py-2 border" nowrap="true">
                                                        {item.IFSC_Code}
                                                    </td>
                                                    <td className="px-3 py-2 border" nowrap="true">
                                                        {item.remarks}
                                                    </td>
                                                    <td className="px-3 py-2 border text-right" nowrap="true">
                                                        {item.status == "pending" ? (
                                                            <span className="text-gray-600">
                                                                <CurFt currency={user?.UserData?.user?.symbal?.name || "INR"} price={item.amount} />
                                                            </span>
                                                        ) : (
                                                            <span className="text-orange-500">
                                                                <CurFt currency={user?.UserData?.user?.symbal?.name || "INR"} price={item.amount} />
                                                            </span>
                                                        )}
                                                    </td>
                                                    <td className="px-3 py-2 border text-left">{item.status} <br /> {(item.status === 'Processed' || item.status === 'Reject') ? 'At :' + format(parseISO(item.updated_at), 'dd MMM, yyyy, HH:mm') : ''}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <>
                                                <tr className="border-b">
                                                    <td colSpan={12} className="px-3 py-2 border">
                                                        No record found
                                                    </td>
                                                </tr>
                                            </>
                                        )}
                                    </>
                                )}
                            </tbody>
                        </table>
                        <Pagination totalPages={totalPages} currentPage={currentPage} setCurrentPage={setCurrentPage} />
                    </div>
                </div>
            </main>
        </div>
    );
}
